import React from 'react';
import { useSync } from '../context/SyncContext';
import './SyncProgressBar.css';

/**
 * Global sync progress bar - visible on ALL pages
 */
function GlobalSyncBar() {
  const { syncProgress, dismissProgress, cancelSync } = useSync();

  if (!syncProgress || syncProgress.status === 'idle') return null;

  const isError = syncProgress.status === 'error';
  const isComplete = syncProgress.status === 'completed';
  const isSyncing = syncProgress.status === 'syncing';

  const percent = syncProgress.progressPercent || 0;

  return (
    <div className={`sync-progress-bar ${isError ? 'error' : ''} ${isComplete ? 'complete' : ''}`}>
      <div className="sync-progress-content">
        <div className="sync-progress-info">
          <span className="sync-progress-icon">
            {isSyncing && '🔄'}
            {isComplete && '✅'}
            {isError && '❌'}
          </span>
          <div className="sync-progress-text">
            <span className="sync-progress-title">
              {isSyncing && `Syncing: ${syncProgress.currentFolder || 'Starting...'}`}
              {isComplete && 'Sync Complete!'}
              {isError && 'Sync Failed'}
            </span>
            <span className="sync-progress-detail">
              {isSyncing && (
                <>
                  Folder {syncProgress.completedFolders || 0}/{syncProgress.totalFolders || '?'} • 
                  {(syncProgress.processedMessages || 0).toLocaleString()}/{(syncProgress.totalMessages || 0).toLocaleString()} messages
                </>
              )}
              {isComplete && `${(syncProgress.insertedMessages || 0).toLocaleString()} new messages imported`}
              {isError && syncProgress.errorMessage}
            </span>
          </div>
        </div>

        {isSyncing && syncProgress.totalMessages > 0 && (
          <div className="sync-progress-bar-track">
            <div 
              className="sync-progress-bar-fill"
              style={{ width: `${percent}%` }}
            />
          </div>
        )}

        {/* Cancel during sync — user feedback 2026-05-19 was that a long sync
            (junk folder etc) couldn't be aborted and they had to wait. */}
        {isSyncing && (
          <button
            className="sync-progress-dismiss"
            onClick={cancelSync}
            title="Cancel sync"
            aria-label="Cancel sync"
          >
            Cancel
          </button>
        )}

        {(isComplete || isError) && (
          <button className="sync-progress-dismiss" onClick={dismissProgress} aria-label="Dismiss">
            ✕
          </button>
        )}
      </div>
    </div>
  );
}

export default GlobalSyncBar;

